import { HStack } from "@gluestack-ui/themed";
import { InterestTypeEnum } from "@repo/core/enums/installments";
import { InterestTypeButton } from "../InterestTypeButton";
import { InterestTypeSelectorProps } from "./types";

export const InterestTypeSelector = ({
  selectedInterestType,
  onInterestTypeChange,
  isLoading
}: InterestTypeSelectorProps) => {
  return (
    <HStack justifyContent="space-between" gap={8}>
      <InterestTypeButton
        type={InterestTypeEnum.WITH_INTEREST}
        isSelected={selectedInterestType === InterestTypeEnum.WITH_INTEREST}
        onPress={() => onInterestTypeChange(InterestTypeEnum.WITH_INTEREST)}
        title="Com Juros"
        subtitle="Melhores parcelas!"
        isDisabled={isLoading}
      />
      <InterestTypeButton
        type={InterestTypeEnum.WITHOUT_INTEREST}
        isSelected={selectedInterestType === InterestTypeEnum.WITHOUT_INTEREST}
        onPress={() => onInterestTypeChange(InterestTypeEnum.WITHOUT_INTEREST)}
        title="Sem Juros"
        isDisabled={isLoading}
      />
    </HStack>
  );
};
